module.exports = __webpack_public_path__ + "promote-sp.svg?dabe8b8ff380d30d8f1cd874f33a8508";